import React from "react";
import Cardimage from "../../atoms/cardimage";
import "./story-card18.m.css";
import { Link } from "@quintype/components";
import Headline from "../../atoms/headline";
import Arrow from "../../atoms/other-icons/Arrow";

function StoryCard18({ story }) {
  const { url, headline, sections, id } = story;

  const slug = sections[0].collection?.slug;
  return (
    <div styleName="wrapper">
      <div className="hide-mobile" id="story-card-18">
        <Cardimage story={story} aspectRatio={[3, 2]} imageType="image3x2" showVideoIcon={true} />
      </div>
      <div className="hide-desktop">
        <Cardimage story={story} aspectRatio={[2, 3]} imageType="image2x3" showVideoIcon={true} />
      </div>
      <div styleName="overlay-bg"></div>
      <div styleName="title">
        <Link href={`/${story.slug}`}>
          <Headline text={headline} headerType={1} headerLevel={1} story={story} id={id} lineClamp={3} />
        </Link>
        <Link href={`/${slug}`}>
          <div styleName="lst-btn">
            <div styleName="lst">Latest Developments</div>
            <Arrow height="24px" width="24px" />
          </div>
        </Link>
      </div>
    </div>
  );
}

export default StoryCard18;
